<template>
    <div class="main">
        <el-tabs v-model="activeName" :before-leave="handleClick">
            <el-tab-pane label="本月" name="0">
            </el-tab-pane>
            <el-tab-pane label="本季度" name="1">
            </el-tab-pane>
            <el-tab-pane label="今年以来" name="2">
            </el-tab-pane>
        </el-tabs>
        <div class="data-card__box">
            <div class="data-card">
                <div class="content">
                    <div class="hd">
                        {{overflow.settlement_money}}
                    </div>
                    <div class="bd">
                        成功付款（元）
                    </div>
                </div>
                <div class="icon">
                    <v-svg-icon class="svg-icon" name="icon-icon2"/>
                </div>
            </div>
            <div class="data-card">
                <div class="content">
                    <div class="hd">
                        {{overflow.tax}}
                    </div>
                    <div class="bd">
                        代缴个税（元）
                    </div>
                </div>
                <div class="icon">
                    <v-svg-icon class="svg-icon" name="icon-icon1"/>
                </div>
            </div>
            <div class="data-card">
                <div class="content">
                    <div class="hd">
                        {{overflow.success_score}}
                    </div>
                    <div class="bd">
                        成功付款（笔）
                    </div>
                </div>
                <div class="icon">
                    <v-svg-icon class="svg-icon" name="icon-icon"/>
                </div>
            </div>
            <div class="data-card">
                <div class="content">
                    <div class="hd">
                        {{overflow.pay_count}}
                    </div>
                    <div class="bd">
                        付款人数（人）
                    </div>
                </div>
                <div class="icon">
                    <v-svg-icon class="svg-icon" name="icon-icon3"/>
                </div>
            </div>
        </div>
        <div class="data-chart__box">
            <div class="continuous"></div>
            <div class="pie"></div>
        </div>
    </div>
</template>

<script>
import echarts from 'echarts'

export default {
    data () {
        return {
            overflow: {},
            activeName: '0'
        }
    },
    mounted () {
        this.getData(0)
    },
    methods: {
        getData (type) {
            this.$http.get('/api/user/index', {
                params: {
                    type
                }
            })
                .then(res => {
                    if (res.code === 0) {
                        this.overflow = res.data
                        this.renderData(res.data)
                    }
                })
                .catch(err => {
                    console.log(err)
                })
        },
        renderData (cData) {
            let chart1 = this.$echarts.init(document.querySelector('.continuous'))
            let chart2 = this.$echarts.init(document.querySelector('.pie'))
            chart1.setOption({
                title: {
                    text: '成功付款概览',
                    textStyle: {
                        fontSize: 14,
                        fontWeight: 700
                    }
                },
                color: ['#3398DB'],
                tooltip: {
                    trigger: 'axis',
                    textStyle: {
                        fontSize: 10,
                        fontWeight: 400
                    },
                    axisPointer: { // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        data: Object.keys(cData.histogram),
                        axisTick: {
                            alignWithLabel: true
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value'
                    }
                ],
                series: [
                    {
                        name: '成功付款（元）',
                        type: 'bar',
                        barWidth: '10',
                        itemStyle: {
                            normal: {
                                // 颜色渐变
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#EE65F5'
                                }, { offset: 0.5, color: '#4B74FF' }, { offset: 1, color: '#4B74FF' }])
                            },
                            emphasis: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#EE65F5'
                                }, { offset: 0.7, color: '#4B74FF' }, { offset: 1, color: '#4B74FF' }])
                            }
                        },
                        data: Object.values(cData.histogram)
                    }
                ]
            })
            chart2.setOption({
                title: {
                    text: '服务状态',
                    left: 'center',
                    top: 20,
                    textStyle: {
                        fontSize: 14,
                        fontWeight: 700
                    }
                },
                tooltip: {
                    trigger: 'item',
                    textStyle: {
                        fontSize: 10,
                        fontWeight: 400
                    },
                    formatter: '{a} <br/>{b}: {c}'
                },
                legend: {
                    x: 'center',
                    y: '350',
                    formatter: (name) => {
                        return name
                    },
                    itemWidth: 15,
                    itemHeight: 10,
                    data: ['待确认', '进行中', '已完成']
                },
                color: [
                    {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [{
                            offset: 0, color: '#00C0F9' // 0% 处的颜色
                        }, {
                            offset: 1, color: '#4B74FF' // 100% 处的颜色
                        }],
                        globalCoord: false // 缺省为 false
                    }, {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [{
                            offset: 0, color: '#FFD034' // 0% 处的颜色
                        }, {
                            offset: 1, color: '#FC5ECF' // 100% 处的颜色
                        }
                        ],
                        globalCoord: false // 缺省为 false
                    }, {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [{ offset: 0, color: '#EE65F5' },
                            { offset: 0.7, color: '#4B74FF' },
                            { offset: 1, color: '#4B74FF' }],
                        globalCoord: false // 缺省为 false
                    }],
                series: [
                    {
                        name: '成员状态',
                        type: 'pie',
                        radius: ['50%', '70%'],
                        avoidLabelOverlap: false,
                        itemStyle: {},
                        label: {
                            normal: {
                                show: false,
                                position: 'center'
                            },
                            emphasis: {
                                show: true,
                                textStyle: {
                                    fontSize: '30',
                                    fontWeight: 'bold'
                                },
                                formatter: '{c}'
                            }
                        },
                        data: [
                            { value: cData.sub_confirm, name: '待确认' },
                            { value: cData.sub_ongoing, name: '进行中' },
                            { value: cData.sub_finished, name: '已完成' }
                        ]
                    }
                ]
            })
            setTimeout(function () {
                window.onresize = function () {
                    chart1.resize()
                    chart2.resize()
                }
            }, 200)
        },
        handleClick (e) {
            this.getData(e)
        }
    }
}

</script>

<style scoped lang="scss">
    @import "../../assets/style/var";

    .main {
        min-width: 980px;
        position: relative;

        .main-date__filter {
            position: absolute;
            right: 0;
            top: 4px;
        }
    }

    .data-card__box {
        display: flex;
        margin: 38px 0 52px;

        .data-card {
            width: 23%;
            /*height: 168px;*/
            background-color: #fff;
            margin-right: 2.63%;
            border-radius: 5px;
            padding: 44px 20px 40px;
            display: flex;
            align-items: center;
            box-shadow: -10px 9px 21px 0 rgba(128, 152, 213, 0.08);

            .content {
                flex: 1;

                .hd {
                    font-family: Arial, sans-serif;
                    color: #333;
                    font-size: 28px;
                    margin-bottom: 17px;
                }

                .bd {

                }
            }

            .icon {
                .svg-icon {
                    font-size: 30px;
                }
            }

            &:nth-child(4n) {
                margin-right: 0;
            }
        }
    }

    .data-chart__box {
        font-size: 0;

        .continuous {
            /*flex: 1;*/
            width: 74.26%;
            height: 400px;
            display: inline-block;
            background-color: #fff;
            margin-right: 2.63%;
            border-radius: 5px;
            box-shadow: -10px 9px 21px 0 rgba(128, 152, 213, 0.08);
            padding: 20px;
        }

        .pie {
            display: inline-block;
            width: 23%;
            padding-bottom: 20px;
            border-radius: 5px;
            height: 400px;
            background-color: #fff;
            box-shadow: -10px 9px 21px 0 rgba(128, 152, 213, 0.08);
        }
    }

    @media screen and (max-width: 1366px) {
        .data-card__box {
            .data-card {
                .content {
                    .hd {
                        font-size: 20px;
                    }
                }
            }
        }
    }
</style>
